import classNames from 'classnames';
import { forwardRef } from 'react';

import CONFIG from './calloutConfig';

import Avatar from '@mui/material/Avatar';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const iconCss = ({ palette }) => ({
  color: palette.common.white,

  '&.bgColorMain_primary': { backgroundColor: palette.primary.main },
  '&.bgColorMain_secondary': { backgroundColor: palette.secondary.main },
  '&.bgColorMain_orange': { backgroundColor: palette.orange.main },
  '&.bgColorMain_cyan': { backgroundColor: palette.cyan.main },
  '&.bgColorMain_green': { backgroundColor: palette.green.main },
  '&.bgColorMain_purple': { backgroundColor: palette.purple.main },
});

export default forwardRef(function CalloutIcon({ className, courseContext, type, ...rest }, ref) {
  const config = CONFIG[type];
  const { color, icon } = config.contexts?.[courseContext] || config;

  return (
    <Avatar {...rest} className={classNames(className, `bgColorMain_${color}`)} css={iconCss} ref={ref}>
      <FontAwesomeIcon icon={icon} />
    </Avatar>
  );
});
